import React from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { syncFromMarketThunk } from "../../store/thunks/rateThunks";
import {
  CurrencyDollarIcon,
  RefreshIcon,
  DocumentDuplicateIcon,
  ChartBarIcon,
  CogIcon,
} from "@heroicons/react/outline";

const QuickActions = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { selectedBranch } = useSelector((state) => state.rate.ui);
  const { user } = useSelector((state) => state.auth);

  const currentBranch = selectedBranch || user?.branchAccess?.primaryBranch;

  const actions = [
    {
      title: "Set Daily Rate",
      description: `Configure today's metal rates${
        currentBranch ? ` for ${currentBranch}` : ""
      }`,
      icon: CurrencyDollarIcon,
      color: "bg-blue-500",
      onClick: () => navigate("/rates/daily"),
      disabled: !currentBranch,
    },
    {
      title: "Sync from Market",
      description: "Update rates from live market",
      icon: RefreshIcon,
      color: "bg-green-500",
      onClick: () => navigate("/rates/daily?action=fetch-market"),
      disabled: !currentBranch,
    },
    // {
    //   title: "Copy Rates",
    //   description: "Copy rates between branches",
    //   icon: DocumentDuplicateIcon,
    //   color: "bg-purple-500",
    //   onClick: () => navigate("/rates/branch-config"),
    // },
    {
      title: "View Analytics",
      description: "Rate trends and insights",
      icon: ChartBarIcon,
      color: "bg-orange-500",
      onClick: () => navigate("/rates/analytics"),
    },
    {
      title: "Configure Charges",
      description: "Set GST, making charges",
      icon: CogIcon,
      color: "bg-gray-600",
      onClick: () => navigate("/rates/charges"),
    },
  ];

  return (
    <div className="bg-white rounded-lg shadow-lg p-6">
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-xl font-bold">Quick Actions</h2>
        {currentBranch && (
          <span className="text-sm text-gray-600">
            Branch: <span className="font-semibold">{currentBranch}</span>
          </span>
        )}
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        {actions.map((action, index) => (
          <button
            key={index}
            onClick={action.onClick}
            disabled={action.disabled}
            className={`group relative p-4 rounded-lg border-2 border-gray-200 
              ${
                action.disabled
                  ? "opacity-50 cursor-not-allowed"
                  : "hover:border-gray-300 hover:shadow-lg"
              } transition-all duration-200 text-left`}
          >
            <div
              className={`absolute -top-3 -right-3 ${
                action.color
              } rounded-full p-2 
              ${
                !action.disabled && "group-hover:scale-110"
              } transition-transform`}
            >
              <action.icon className="h-5 w-5 text-white" />
            </div>
            <h3 className="font-semibold text-gray-900 mb-1">{action.title}</h3>
            <p className="text-sm text-gray-600">{action.description}</p>
          </button>
        ))}
      </div>
      {!currentBranch && (
        <p className="text-sm text-amber-600 mt-4">
          ⚠️ Please select a branch to enable branch-specific actions
        </p>
      )}
    </div>
  );
};

export default QuickActions;
